<script>
	import FormText from '$lib/components/Form-Text.svelte';
	import FormMessage from '$lib/components/Form-Mesage.svelte';

	import { fly, fade } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';

	let email = '';
	let name = '';
	let note = '';
	let errors = false;
	let success = false;
	let sending = false;
	let nameValid = false;
	let emailValid = false;
	let noteValid = false;
	$: valid = !emailValid && !nameValid && !noteValid;
	let submit = async () => {
		sending = true;
		if (!valid) {
			sending = false;
			return;
		}
		var form = document.getElementById('contact');
		var data = new FormData(document.getElementById('contact'));

		fetch(document.getElementById('contact').action, {
			method: form.method,
			body: data,
			headers: {
				Accept: 'application/json'
			}
		})
			.then((response) => {
				if (response.ok) {
					console.log(response);

					success = true;
					sending = false;
					form.reset();
				} else {
					response.json().then((data) => {
						console.log(data);
						if (Object.hasOwn(data, 'errors')) {
							errors = data['errors'].map((error) => error['message']).join(', ');
							sending = false;
						} else {
							errors = 'Oops! There was a problem submitting your form';
							sending = false;
						}
					});
				}
			})
			.catch((error) => {
				console.log(error);
				errors = 'Oops! There was a problem submitting your form';
				sending = false;
			});
	};
	const errorTransition = { y: -5, duration: 50, easing: cubicOut, delay: 0 };
</script>

<svelte:head>
	<title>Contact | Jordanian Food for Funds</title>
	<meta
		name="description"
		content="Jordanian Food for Funds is a pop up dinner on April 14th from 5-8pm to raise money for Syrian refugee education in Jordan."
	/>
</svelte:head>
<main>
	<div>
		<h1 class="secondary_heading">Contact</h1>
		<p class="text-block">
			We would love to hear from you, please leave us a note using the form below. <br /> Or send us
			an email: <a href="mailto:team@rootsforrefugees.org">team@rootsforrefugees.org</a>
		</p>
		{#if success}
			<div transition:fade={{ duration: 200, delay: 300 }} class="success">
				<h2 class="tertiary_heading">Note Sent!</h2>
				<p>Thank you for your submission, we will be in touch soon.</p>
			</div>
		{:else}
			<form
				action="https://formspree.io/f/xjvnrlaz"
				method="POST"
				on:submit|preventDefault={submit}
				id="contact"
				transition:fade={{ duration: 200 }}
			>
				<FormText
					formId="name"
					label="Name"
					required="true"
					auto="name"
					disabled={sending}
					bind:invalid={nameValid}
				/>
				<FormText
					formId="email"
					label="Email"
					type="email"
					required="true"
					auto="email"
					disabled={sending}
					bind:invalid={emailValid}
				/>
				<FormMessage
					formId="message"
					label="Note"
					required="true"
					auto="false"
					disabled={sending}
					bind:invalid={noteValid}
				/>
				{#if errors}
					<p transition:fly={errorTransition} class="form-error">{errors}</p>
				{/if}
				<button class="btn" type="submit" disabled={sending}
					>{sending ? 'sending...' : 'send'}</button
				>
			</form>
		{/if}
	</div>
	<div>
		<enhanced:img
			class="banner side"
			src="$lib/images/webp/Ronan-Furuta-Jordan-71.webp"
			alt="Looking down the entrance to Petra at the treasuery"
		/>
	</div>
	<div class="banner-cont">
		<enhanced:img
			class="banner"
			src="$lib/images/webp/Ronan-Furuta-Jordan-34.webp"
			alt="Jordan's magnificent Wadi Rum Desert at sunrise."
		/>
	</div>
</main>

<style>
	main {
		display: grid;
		grid-template-columns: minmax(50px, 900px) auto;
		grid-gap: 4em;
		grid-row-gap: 3em;
	}
	.banner {
		width: 100%;
		height: auto;
	}
	.side {
		margin-top: 4em;
	}
	.banner-cont {
		grid-column: span 2;
	}
	form {
		margin-top: 2em;
	}
	form .btn {
		margin-top: 2em;
	}
	.success {
		width: 100%;
		height: 30em;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	@media only screen and (max-width: 1400px) {
		main {
			grid-column-gap: 2em;
		}
	}
	@media only screen and (max-width: 1000px) {
		main {
			grid-template-columns: 1fr;
			grid-template-rows: auto auto auto;
		}
		.banner-cont {
			grid-column: span 1;
		}
	}
</style>
